import $ from 'jquery';
import moment from 'moment';

const defaults = {
  // local storage key used to save the currently applied filter
  storageKey: 'currentCalendarFilter',

  // Button text displayed as the pagination to the next page of events
  paginationLabel: 'Load More Events',

  // Mobile only drop down label that houses the filtering options
  filtersLabel: 'Filter by...',

  // Force the filters to be automatically determined by the post types present in the feed.
  filterByPostTypes: false,

  // A simple indicator to determine the build out of filters
  useFilters: false,

  // Used to pass in an object of filters which use key value pairs.
  // {Object}
  //   @key: Name that will appear as the filter button text
  //   @value: ID of post type or navigation term
  filters: false,
};

// These filters are used if the filterByPostTypes is enabled. Present post
// types are then added to this object, then the filters are made from those.
const defaultFilters = {
  All: 2,
};

function CalendarFeed(element, options) {
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.filters = this.getFilters();
  this.init();
}

CalendarFeed.prototype = {
  init() {
    this.buildCalendar();
    if (this.settings.useFilters) {
      this.createFilters();
    }
  },
  buildCalendar() {
    const $posts = this.$element.find('.node');
    const group = '<div class="group"></div>';
    let currentYear = null;
    let currentMonth = '';
    let $group;

    // Manage the types of calendar filters being created
    $posts.each((i, post) => {
      const $post = $(post);
      const dates = ['start', 'end'];
      const oDates = {};

      // Parse the start/end timestamps using the moment.js framework
      $.each(dates, (j, type) => {
        const timestamp = parseInt($post.find('.event-date-tile').attr(`data-timestamp-${type}`), 10);
        const date = moment.unix(timestamp);
        oDates[type] = {
          timestamp,
          month: date.format('MMMM'),
          mon: date.format('MMM'),
          day: date.format('D'),
          dow: date.format('ddd'),
          year: date.format('YYYY'),
        };
      });

      // Add the post into a month grouping
      if (oDates.start.month.length && currentMonth !== oDates.start.month) {
        currentMonth = oDates.start.month;
        $group = $(group);
        $group.addClass(oDates.start.month.toLowerCase());
        $group.append(`<h3 class="group-title">${oDates.start.month}</h3>`);
        $post.before($group);

        // Set year labels followed by the associated months of that year
        if (oDates.start.year && oDates.start.year > currentYear) {
          const $year = $(`<span class="group-year">${oDates.start.year}</span>`);
          $group.before($year);
          currentYear = oDates.start.year;
        }
      }

      // Dynamically create the date tile for the event display
      const $tile = $post.find('.event-date-tile');
      $tile.find('.day-of-week').text(oDates.start.dow);
      $tile.find('.month').text(oDates.start.month);
      $tile.find('.day').text(oDates.start.day);

      // Handle date ranges
      if (oDates.start.timestamp !== oDates.end.timestamp) {
        const isSameMonth = oDates.start.month === oDates.end.month;
        const isSameDay = oDates.start.day === oDates.end.day;
        const isSameYear = oDates.start.year === oDates.end.year;

        // This identifies an event which spans multiple days within the same month
        if (isSameMonth && !isSameDay && isSameYear) {
          $post.addClass('multiple-day-event');
          $tile.find('.day').text(`${oDates.start.day}-${oDates.end.day}`);
        }
      }

      // Add the grouped posts to the display
      $post.appendTo($group);
    });

    // Alter the text of the next pager button
    $('.pager-next a', this.$element).text(this.settings.paginationLabel);

    // Add a helper class
    this.$element.addClass('ready');
  },
  filterHandler(event) {
    event.preventDefault();
    $(this).next('.filters').toggleClass('expanded');
  },
  getFilters() {
    // If custom filters where passed, use them, if not use the defaults.
    let data = this.settings.filters ? this.settings.filters : defaultFilters;
    // If the filter by post types flag is set, force that filtering option.
    if (this.settings.filterByPostTypes) {
      data = defaultFilters;
    }
    return data;
  },
  createFilters() {
    const $element = this.$element;
    const $posts = $element.find('.node');
    let $filters = $('<div class="filters"></div>');
    const filter = '<div class="filter"></div>';
    let types = [];
    let ids = [];

    // Create the proposed filters
    $.each(this.filters, (type, id) => {
      types.push(type);
      ids.push(id);
    });

    // Using the proposed filters, generate relevant filters of those types
    // that are actually present or use the semi default, filter by post type.
    const data = this.settings.filterByPostTypes
      ? this.getDefaultData(types, ids)
      : this.getCustomizedData(types, ids)
    ;

    // Using the provided date, rebuild the arrays using relevant data.
    types = data.types;
    ids = data.ids;

    // Get the latest selected filter.
    let currentFilter = sessionStorage.getItem(this.settings.storageKey) || ids[0];

    // See if a hash was passed, if so let's filter by that instead later on.
    let hash = window.location.hash;
    if (hash.length > 1) {
      hash = hash.substr(1); // Remove the hash symbol #
      hash = decodeURIComponent(hash); // Normalize the filter passed
    }

    // Create filters
    $.each(types, (i, type) => {
      const $filter = $(filter);
      // Use the type key to identify the associated filter id
      const id = ids[i];

      // Check to see if this filter is being forced to be filtered by using
      // a url hash.
      if (hash.length && hash.toLowerCase() === type.toLowerCase()) {
        currentFilter = id;
      }

      // Add the type to the filter
      $filter.text(type);

      // Add a class name to theme the filter
      $filter.addClass(`show-${ids[i]}`);

      // Add the newly created filter
      $filters.append($filter);

      // Add a click handler
      $filter.bind('click', () => {
        // Default to all posts in calendar feed
        let $show = $posts;

        // Filter what posts to display if not all option
        if (type !== 'All') {
          $show = $posts.filter(
            (j, element) => $.inArray(type, $(element).data('types')) !== -1,
          );
        }

        // Manage the active filter styling
        $filters.not(this).removeClass('active');
        $(this).addClass('active');

        // hide all events that aren't of this type
        $posts.not($show).stop(true, true).animate({
          opacity: 'hide',
          height: 'hide',
        }, 300).removeClass('show');

        // show all events that are of this type
        $show.stop(true, true).animate({
          opacity: 'show',
          height: 'show',
        }, 300).addClass('show');

        // Set the current filter into session storage
        sessionStorage.setItem(this.settings.storageKey, id);
        currentFilter = id;

        // Check to see if the event group is empty
        $element.find('.group').each((j, element) => {
          const $shown = $('.node.show', element);
          const result = $shown.length ? 'show' : 'hide';

          // Add a helper class for the use with the year function below
          if ($shown.length) {
            $(element).addClass('show');
          } else {
            $(element).removeClass('show');
          }

          // Manages the visibility of the group
          $(element).stop(true, true).animate({
            opacity: result,
            height: result,
          }, 300);
        });

        // Check to see if the group year should display or not
        $element.find('.group-year').each((j, element) => {
          const $shown = $(element).nextUntil('.group-year').filter('.show');
          const result = $shown.length ? 'show' : 'hide';
          $(element).stop(true, true).animate({
            opacity: result,
            height: result,
          }, 300);
        });
      });
    });

    // Add a drop down controller for mobile
    const $ctrl = $(`<h3 class="ctrl">${this.settings.filtersLabel}</h3>`);
    $ctrl.bind('click', this.filterHandler);

    // Add the drop down controller for mobile display
    $element.find('.view-header').append($ctrl, $filters);

    // Make this an jquery array of filters reference rather than a container
    // reference.
    $filters = $filters.find('.filter');

    // Simulate a click event for the last or default calendar filter
    $filters.filter(`.show-${currentFilter}`).trigger('click');
  },
  getDefaultData(_types, _ids) {
    const $element = this.$element;
    const $posts = $element.find('.node');

    const types = _types;
    const ids = _ids;

    // Dynamically create the filter types and identify the posts that belong
    // to each one.
    $posts.each((i, post) => {
      const $post = $(post);

      // Extract the post type
      let type = $('.post-type', post).text();

      // If the post type is the generic Event, set the label to All instead.
      if (type === 'Event') {
        type = 'All';
      }

      let id = 0;
      const classes = $post.attr('class');
      const regex = /\w?pt([0-9]+)/;

      // Make filters by types found if were using the default filters
      if (regex.test(classes)) {
        id = regex.exec(classes)[1];
      }

      // Make filters by post type
      if ($.inArray(type, types) === -1) {
        types.push(type);
        ids.push(id);
      }

      // Add a data types to identify this when a filter is clicked
      $post.data('types', [type]);
    });

    return {
      types,
      ids,
    };
  },
  getCustomizedData(_types, _ids) {
    const $element = this.$element;
    const $posts = $element.find('.node');
    const types = [];
    const ids = [];

    // Keep track of the types and ids that have been identified within this content.
    const indexes = [];

    // Dynamically create the filter types and identify the posts that belong
    // to each one.
    $posts.each((i, post) => {
      const $post = $(post);
      const classes = $post.attr('class');
      const regex = /\w?[wp]t([0-9]+)/g; // Filter could be either wt or pt.
      const aTypes = [];

      // Add the post type by default
      aTypes.push($('.post-type', post).text());

      // If the post type is the generic Event, set the label to All instead.
      if (aTypes[0] === 'Event') {
        aTypes[0] = 'All';
      }

      // Iterates through all matches made to see what this post should be
      // filtered by from the filters assigned
      let aResults;
      // eslint-disable-next-line no-cond-assign
      while ((aResults = regex.exec(classes)) !== null) {
        const result = parseInt(aResults[1], 10);
        if ($.inArray(result, _ids) !== -1) {
          const index = _ids.indexOf(result);
          // Check to see if index has already been added, if not, add it.
          if ($.inArray(index, indexes) === -1) {
            indexes.push(index);
          }
          // Add this type to the post since it's been found
          aTypes.push(_types[index]);
        }
      }

      // Add a data id to identify this type when the filter is clicked
      $post.data('types', aTypes);
    });

    // Create new types and ids of the relevant types found using the
    // supplied custom filters
    $.each(indexes.sort(), (i, index) => {
      types.push(_types[index]);
      ids.push(_ids[index]);
    });

    return {
      types,
      ids,
    };
  },
};

export default CalendarFeed;



// WEBPACK FOOTER //
// ./CalendarFeed.js